/* eslint-disable import/prefer-default-export */

export const PlusLogo = () => (
  <svg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g id='Paid content + Logo/Responsive4'>
      <path id='+' d='M5.41444 16V9.88945H0V6.07035H5.41444V0H9.54545V6.07035H15V9.88945H9.54545V16H5.41444Z' fill='#111111'/>
    </g>
  </svg>
);